import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import { delay } from 'redux-saga'

import { showGeneralError, hideGeneralError } from '../actions/general.actions';
import { GENERIC_ERROR_MESSAGE } from "../config/messages";
import {
    GET_CONTENT_BY_TAG,
    SEARCH_ENTITY_IN_SITE,
    ADD_MOVIE_TO_FAVORITE_FROM_SEARCH,
    REMOVE_MOVIE_FROM_FAVORITE_FROM_SEARCH,
    ADD_ARTICLE_FROM_FAVORITE_FROM_SEARCH,
    REMOVE_ARTICLE_FROM_FAVORITE_FROM_SEARCH
} from "../actions/types";
import { getContentByTag, searchEntityInSite } from '../api/searchresults.api';
import { getContentByTagSucceeded, searchEntityInSiteSucceeded } from "../actions/searchresults.actions";
import { showSpinner, hideSpinner } from '../actions/loading.actions';
import { addMovieToFavorite, removeMovieFromFavorite } from '../api/movies.api';
import { addNewsToFavorite, removeNewsFromFavorite } from '../api/news.api';

function* getContentByTagSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getContentByTag, action.payload);
        if (response.status === 200) {
            yield put(getContentByTagSucceeded(response.data));
            yield put(hideSpinner());
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* searchEntityInSiteSaga(action) {
    try {
        let allEntities = [{
            searchedText: action.payload.searchedText,
            entity: 'filme'
        }, {
            searchedText: action.payload.searchedText,
            entity: 'articole'
        },
        {
            searchedText: action.payload.searchedText,
            entity: 'celebritati'
        },
        {
            searchedText: action.payload.searchedText,
            entity: 'cinematografe'
        }, {
            searchedText: action.payload.searchedText,
            entity: 'evenimente'
        },
        {
            searchedText: action.payload.searchedText,
            entity: 'festivaluri'
        }];

        yield put(showSpinner());
        const response = yield all([
            call(searchEntityInSite, allEntities[0]),
            call(searchEntityInSite, allEntities[1]),
            call(searchEntityInSite, allEntities[2]),
            call(searchEntityInSite, allEntities[3]),
            call(searchEntityInSite, allEntities[4]),
            call(searchEntityInSite, allEntities[5])
        ]);

        let allStatusOk = true;

        response.forEach(r => {
            if (r.status !== 200) {
                allStatusOk = false;
            }
        });

        if (allStatusOk) {
            let combinedResponse = {};
            combinedResponse.movies = response[0].data;
            combinedResponse.articles = response[1].data;
            combinedResponse.celebrities = response[2].data;
            combinedResponse.movieTheaters = response[3].data;
            combinedResponse.events = response[4].data;
            combinedResponse.festivals = response[5].data;
            // combinedResponse.festivaluri.push(combinedResponse.festivaluri[0]);
            
            yield put(searchEntityInSiteSucceeded(combinedResponse));
            yield put(hideSpinner());
        }

    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addMovieToFavoriteFromSearchSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(addMovieToFavorite, action.payload);
        if (response.status === 201) {
            yield put(hideSpinner());
            let prevState = yield select(state => state.searchResults);
            let index = prevState.movies.findIndex(element => element.film_uuid === action.payload);
            prevState.movies[index].favorite.push({ uuid: response.data.data.id });
            const addMovieToFav = { ...prevState };
            yield put(searchEntityInSiteSucceeded(addMovieToFav));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeMovieFromFavoriteFromSearchSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeMovieFromFavorite, action.payload.uuid); 
        if (response.status === 204) {
            yield put(hideSpinner());
            let prevState = yield select(state => state.searchResults);
            let index = prevState.movies.findIndex(element => element.film_uuid === action.payload.film_uuid);
            prevState.movies[index].favorite = [];
            const remMovieFromFav = { ...prevState };
            yield put(searchEntityInSiteSucceeded(remMovieFromFav));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addArticleToFavoriteFromSearchSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(addNewsToFavorite, action.payload);
        if (response.status === 201) {
            yield put(hideSpinner());
            let prevState = yield select(state => state.searchResults);
            let index = prevState.articles.findIndex(element => element.article_uuid === action.payload);
            prevState.articles[index].favorite.push({ uuid: response.data.data.id });
            const addNewsToFav = { ...prevState };
            yield put(searchEntityInSiteSucceeded(addNewsToFav));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeArticleFromFavoriteFromSearchSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeNewsFromFavorite, action.payload.uuid);
        if (response.status === 204) {
            yield put(hideSpinner());
            let prevState = yield select(state => state.searchResults);
            let index = prevState.articles.findIndex(element => element.article_uuid === action.payload.article_uuid);
            prevState.articles[index].favorite = [];
            const remNewsFromFav = { ...prevState };
            yield put(searchEntityInSiteSucceeded(remNewsFromFav));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}



export default function* searchResultsSaga() {
    yield takeLatest(GET_CONTENT_BY_TAG, getContentByTagSaga);
    yield takeLatest(SEARCH_ENTITY_IN_SITE, searchEntityInSiteSaga);
    yield takeLatest(ADD_MOVIE_TO_FAVORITE_FROM_SEARCH, addMovieToFavoriteFromSearchSaga);
    yield takeLatest(REMOVE_MOVIE_FROM_FAVORITE_FROM_SEARCH, removeMovieFromFavoriteFromSearchSaga);
    yield takeLatest(ADD_ARTICLE_FROM_FAVORITE_FROM_SEARCH, addArticleToFavoriteFromSearchSaga);
    yield takeLatest(REMOVE_ARTICLE_FROM_FAVORITE_FROM_SEARCH, removeArticleFromFavoriteFromSearchSaga);
}



// WEBPACK FOOTER //
// ./src/SHARED/sagas/searchresults.saga.js